export default "__VITE_ASSET__mqYR59eV__"